import { FONT_BASE_SIZE } from 'styles/constants/fonts';

export const prem = (value: number): string => `${value / FONT_BASE_SIZE}rem`;
export const HEADER_HPADDING = 10;
